import './eleccion.css';

/**
 * RV Filtros (componentes.md §4b): recortan **la misma lista** de un apartado por estado o tipo (Por revisar ·
 * Fusionadas · Descartadas…). Píldoras sueltas de 36 en una zona de 44, borde `--rv-rule`, la elegida en negro. **Sin
 * cifras** en Clientes (G140). Esta versión las enseña todas (`plegable=false` del diseño); el plegado en abanico con
 * «asomo» queda para cuando una pantalla tenga más filtros de los que caben.
 */
export interface Filtro {
    etiqueta: string;
    /** Solo donde el diseño la pide y la API la da («Sin leer» de los avisos, 5.1); nunca inventada (R-4). */
    cifra?: number | null;
}

export function Filtros({ items, valor, onCambio, etiqueta }: { items: readonly Filtro[]; valor: number; onCambio: (i: number) => void; etiqueta: string }) {
    return (
        <div role="radiogroup" aria-label={etiqueta} className="rv-filtros" data-rv-tira="">
            {items.map((f, i) => (
                <button
                    key={f.etiqueta}
                    type="button"
                    role="radio"
                    aria-checked={i === valor}
                    className={`rv-filtros__b${i === valor ? ' rv-filtros__b--on' : ''}`}
                    onClick={() => {
                        if (i !== valor) {
                            onCambio(i);
                        }
                    }}
                >
                    <span>
                        {f.etiqueta}
                        {f.cifra != null && f.cifra > 0 && <b className="rv-filtros__n">{f.cifra}</b>}
                    </span>
                </button>
            ))}
        </div>
    );
}
